import React, { useState, useContext, useEffect } from "react";
import "PostVisibilityOptionsModal/styles.scss";

const PostVisibilityOptionsButton = ({ post, updateModalState }) => {
  let displayLabel;
  let iconUrl;
  switch (post.visibility) {
    case "public":
      displayLabel = "Public";
      iconUrl = "/images/icons/globe.svg";
      break;
    case "contact_groups":
      displayLabel = "Contact groups";
      iconUrl = "/images/icons/users.svg";
      break;
    case "private":
      displayLabel = "Recipients only";
      iconUrl = "/images/icons/lock-outline-icon-black.svg";
      break;
    case "recipients_only":
      displayLabel = "Recipients only";
      iconUrl = "/images/icons/lock-outline-icon-black.svg";
      break;
    case "hidden":
      displayLabel = "Hidden";
      iconUrl = "/images/icons/x.svg";
      break;

    default:
      break;
  }

  return (
    <div>
      {post.visibility && (
        <div
          className={"ps-visibility-options__container"}
          onClick={() => {
            updateModalState(true);
          }}
        >
          <img
            src={iconUrl}
            style={{
              height: "14px",
              marginBottom: "",
            }}
            alt=""
          />
          <div
            style={{
              fontSize: "13px",
              marginLeft: "8px",
              marginRight: "12px",
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
              lineHeight: "23px",
            }}
          >
            {displayLabel}
          </div>

          <div className="ps-visibility-options__share-button">
            <img
              className="ps-visibility-options__share-button-icon"
              src="/images/icons/black-link-icon.svg"
            />
            Share
          </div>
          {/* <div
            style={{
              display: "flex",
              alignItems: "center"
            }}
          > */}

          {/* <img
              className="d-inline"
              src={"/images/icons/open-carat.svg"}
                style={{ width: "11px", height: "9px", marginLeft: "auto", marginTop: "2px" }}
              alt=""
            /> */}
          {/* </div> */}
        </div>
      )}
    </div>
  );
};
export { PostVisibilityOptionsButton };
